module.exports = __webpack_public_path__ + "static/media/exxon_logo.a281d0cf.png";